import React, { useEffect } from "react";

const GOLD = "#b8935a";

// Modal de detalle de un resort: se abre al hacer clic en una tarjeta de
// "Discover Our Resorts" y muestra la versión grande de la foto (las tarjetas
// solo cargan el thumbnail). Controlado por el resort seleccionado: si es null,
// no hay modal.
function ResortDetailModal({ resort, perfectForLabel, closeLabel, onClose }) {
  useEffect(() => {
    if (typeof document === "undefined" || !resort) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [resort, onClose]);

  if (!resort) {
    return null;
  }

  return (
    // Velo y blur inline: son valores arbitrarios y public/tailwind.css solo se
    // regenera en prestart/prebuild, así inline no dependen de eso.
    <div
      className="fixed inset-0 flex items-start justify-center overflow-y-auto px-4 py-8"
      style={{
        zIndex: 1300,
        background: "rgba(11,16,48,0.72)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)"
      }}
      role="dialog"
      aria-modal="true"
      aria-label={resort.name}
      onClick={onClose}
    >
      <div
        className="my-auto flex w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white"
        style={{ boxShadow: "0 30px 80px rgba(8,16,48,0.45)" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="relative">
          <img src={resort.largeImage} alt={resort.name} className="block w-full" />

          <button
            type="button"
            className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-white transition hover:bg-black/70"
            style={{ background: "rgba(8,12,32,0.55)" }}
            aria-label={closeLabel}
            onClick={onClose}
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="p-6 md:p-8">
          <h2 className="m-0 text-xl font-black leading-tight text-marival-navy md:text-2xl">
            {resort.name}
          </h2>
          <p
            className="m-0 mt-3 text-sm font-semibold uppercase tracking-[0.18em]"
            style={{ color: GOLD }}
          >
            {resort.tagline}
          </p>
          <p className="m-0 mt-4 text-base leading-7 text-slate-600">{resort.description}</p>

          <div className="mt-6 border-t border-slate-100 pt-5">
            <p className="m-0 text-xs font-semibold uppercase tracking-[0.15em] text-marival-navy">
              {perfectForLabel}
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              {resort.perfectFor.map((tag, i) => (
                <span
                  key={i}
                  className="rounded-full bg-[#eaf6fb] px-3 py-1 text-xs font-medium text-marival-sky"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResortDetailModal;
